export default __webpack_public_path__ + "static/media/EditPencil.504dbdf6.svg";